import Vue from 'vue'
import VueI18n from 'vue-i18n';
import { getLanguage, loadLanguage } from "./utils/utils";

Vue.use(VueI18n);
const lang = getLanguage();
moment.locale(lang);

const messages = await loadLanguage();

const i18n = new VueI18n({
    locale: lang,
    messages,
    fallbackLocale: lang,
    silentTranslationWarn: true
});

export default i18n
